export default __webpack_public_path__ + "static/Overpass-Regular-e378b7865567532c23c4cb016dd30564.woff2";